import type { FC } from "react";

import styled from "styled-components";

import { PixelPlaceholderLoader, IconButton } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";

import { Delimiter } from "./BillingCycle/BillingCycleStyled";
import {
    Wrapper,
    ContentWrapper,
    LeftContentContainer,
    RightContentContainer,
    IconButtonContainer,
} from "./StyledComponents";

const DashboardWidgetLoaderHeader = styled.div<{ marginBottom?: number; gap?: number; marginLeft?: number }>`
    display: grid;
    gap: ${({ gap }) => (gap ? `${gap}px` : "6px")};
    margin-bottom: ${({ marginBottom }) => (marginBottom ? `${marginBottom}px` : "0")};
    margin-left: ${({ marginLeft }) => (marginLeft ? `${marginLeft}px` : "0")};
`;

const DashboardWidgetLoaderHeaderFlex = styled(DashboardWidgetLoaderHeader)`
    display: flex;
    justify-content: space-between;
`;

interface IAfterTrialPopupLoaderProps {
    popUpHeight?: number;
}

export const AfterTrialPopupLoader: FC<IAfterTrialPopupLoaderProps> = ({ popUpHeight }) => {
    return (
        <Wrapper popUpHeight={popUpHeight}>
            <ContentWrapper>
                <LeftContentContainer>
                    <div>
                        <DashboardWidgetLoaderHeader marginBottom={49}>
                            <PixelPlaceholderLoader
                                width={373}
                                height={33}
                            />
                            <PixelPlaceholderLoader
                                width={272}
                                height={15}
                            />
                        </DashboardWidgetLoaderHeader>
                        <DashboardWidgetLoaderHeader marginBottom={32}>
                            <PixelPlaceholderLoader
                                width={237}
                                height={15}
                            />
                            <PixelPlaceholderLoader
                                width={200}
                                height={15}
                            />
                        </DashboardWidgetLoaderHeader>
                        <DashboardWidgetLoaderHeader marginBottom={32}>
                            <PixelPlaceholderLoader
                                width={237}
                                height={15}
                            />
                            <PixelPlaceholderLoader
                                width={200}
                                height={15}
                            />
                        </DashboardWidgetLoaderHeader>
                        <DashboardWidgetLoaderHeader marginBottom={300}>
                            <PixelPlaceholderLoader
                                width={237}
                                height={15}
                            />
                            <PixelPlaceholderLoader
                                width={200}
                                height={15}
                            />
                        </DashboardWidgetLoaderHeader>
                    </div>
                </LeftContentContainer>
                <RightContentContainer>
                    <div>
                        <DashboardWidgetLoaderHeader marginBottom={12}>
                            <PixelPlaceholderLoader
                                width={300}
                                height={15}
                            />
                        </DashboardWidgetLoaderHeader>
                        <DashboardWidgetLoaderHeader
                            marginBottom={90}
                            gap={12}
                        >
                            <PixelPlaceholderLoader
                                width={185}
                                height={12}
                            />
                            <PixelPlaceholderLoader
                                width={185}
                                height={12}
                            />
                            <PixelPlaceholderLoader
                                width={185}
                                height={12}
                            />
                            <PixelPlaceholderLoader
                                width={185}
                                height={12}
                            />
                            <PixelPlaceholderLoader
                                width={185}
                                height={12}
                            />
                        </DashboardWidgetLoaderHeader>
                        <DashboardWidgetLoaderHeader marginBottom={17}>
                            <PixelPlaceholderLoader
                                width={225}
                                height={15}
                            />
                        </DashboardWidgetLoaderHeader>
                        <DashboardWidgetLoaderHeader
                            marginBottom={17}
                            marginLeft={22}
                        >
                            <PixelPlaceholderLoader
                                width={69}
                                height={12}
                            />
                        </DashboardWidgetLoaderHeader>
                        <DashboardWidgetLoaderHeader
                            marginBottom={12}
                            marginLeft={22}
                        >
                            <PixelPlaceholderLoader
                                width={185}
                                height={12}
                            />
                        </DashboardWidgetLoaderHeader>
                        <DashboardWidgetLoaderHeader
                            marginBottom={17}
                            marginLeft={22}
                        >
                            <PixelPlaceholderLoader
                                width={69}
                                height={12}
                            />
                        </DashboardWidgetLoaderHeader>
                        <DashboardWidgetLoaderHeader
                            marginBottom={24}
                            marginLeft={22}
                        >
                            <PixelPlaceholderLoader
                                width={185}
                                height={12}
                            />
                        </DashboardWidgetLoaderHeader>
                        <Delimiter />
                        <DashboardWidgetLoaderHeaderFlex
                            marginBottom={8}
                            marginLeft={22}
                        >
                            <PixelPlaceholderLoader
                                width={133}
                                height={12}
                            />
                            <PixelPlaceholderLoader
                                width={55}
                                height={12}
                            />
                        </DashboardWidgetLoaderHeaderFlex>
                        <DashboardWidgetLoaderHeaderFlex
                            marginLeft={22}
                            marginBottom={96}
                        >
                            <PixelPlaceholderLoader
                                width={133}
                                height={12}
                            />
                            <PixelPlaceholderLoader
                                width={55}
                                height={12}
                            />
                        </DashboardWidgetLoaderHeaderFlex>
                        <IconButtonContainer>
                            <IconButton
                                isDisabled={true}
                                iconName="arrow-right"
                                placement={"right"}
                            >
                                {translate("pro.packages.button")}
                            </IconButton>
                        </IconButtonContainer>
                    </div>
                </RightContentContainer>
            </ContentWrapper>
        </Wrapper>
    );
};
